/*
 * Action Types
 */
export enum SchoolSettingsTypes {
  GET_SCHOOL_SETTINGS_REQUEST = '@orders/GET_SCHOOL_SETTINGS_REQUEST',
  GET_SCHOOL_SETTINGS_SUCCESS = '@orders/GET_SCHOOL_SETTINGS_SUCCESS',
  GET_SCHOOL_SETTINGS_FAILURE = '@orders/GET_SCHOOL_SETTINGS_FAILURE',

  UPDATE_SCHOOL_SETTINGS_REQUEST = '@orders/UPDATE_SCHOOL_SETTINGS_REQUEST',
  UPDATE_SCHOOL_SETTINGS_SUCCESS = '@orders/UPDATE_SCHOOL_SETTINGS_SUCCESS',
  UPDATE_SCHOOL_SETTINGS_FAILURE = '@orders/UPDATE_SCHOOL_SETTINGS_FAILURE',

  UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_REQUEST = '@orders/UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_REQUEST',
  UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_SUCCESS = '@orders/UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_SUCCESS',
  UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_FAILURE = '@orders/UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_FAILURE',
}

/*
 * Data types
 */
export interface SchoolSettingsInterface {
  id?: string;
  releaseType?: number | null;
  paymentType?: number | null;
  creditExpirationLink?: boolean | null;
  creditExpirationDays?: number | null;
  creditExpirationDate?: number | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  transportOperatorId?: string;
  schoolSettingsId?: string;
  schoolId?: string;
  updateStudents?: boolean | null;
}

/*
 * State type
 */
export interface SchoolSettingsState {
  readonly schoolSettingsData: SchoolSettingsInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
